/* データリスト */
import React from 'react';
import { FormControl } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from './Messages';
var DataList = function (_a) {
    var id = _a.id, fm_id = _a.fm_id, sources = _a.sources, label = _a.label, need = _a.need, value = _a.value, handleChange = _a.handleChange, message = _a.message, help_msg = _a.help_msg, disabled = _a.disabled, handleBlur = _a.handleBlur, maxlength = _a.maxlength;
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: disabled ? (React.createElement("div", { className: "paragraph" }, value)) : (React.createElement(React.Fragment, null,
            React.createElement(FormControl, { type: "text", list: id, "data-fm_id": fm_id, value: value, onChange: handleChange, onBlur: handleBlur, maxLength: maxlength }),
            React.createElement("datalist", { id: id }, sources.map(function (src) {
                return (React.createElement("option", { key: src.key, value: src.key }, src.value));
            })),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message }))) }));
};
export default DataList;
